import { SystemNotice } from "../models/systemNotice/systemNotice";
import { BaseWebService } from "./base.web.service";

export class SystemNoticesWebService extends BaseWebService {

  // Publieke meldingen (geen authenticatie vereist).
  public async getPublicActive(): Promise<SystemNotice[]> {
    const headers = await this.getHeadersJson(false);
    const url = `${this.appConfig.serviceNotificationsUrl}/public/v1/system-notices/active`;
    return this.makeRequest(url, 'GET', headers);
  }

  // Meldingen voor ingelogde gebruikers; zonder rechten komt er geen data terug.
  public async getAccountActive(organizationId?: string): Promise<SystemNotice[]> {
    const headers = organizationId
      ? await this.getHeadersJsonForOrganization(organizationId)
      : await this.getHeadersJson(true);
    const url = `${this.appConfig.serviceNotificationsUrl}/api/v1/system-notices/active`;
    return this.makeRequest(url, 'GET', headers);
  }
}
